export enum PieChartSize {
  small = 'SMALL',
  medium = 'MEDIUM',
  large = 'LARGE',
  extraLarge = 'EXTRA-LARGE',
}
